export default __webpack_public_path__ + "static/resume-03a27f9b5669e3f60b87e25c24687c76.pdf";